$('.quick-single-mobile').click(function() {
    var index = $(this).index('.quick-single-mobile');
    $('.list-size').hide();
    $('.list-size-' + (index + 1)).show();
});


if (!customElements.get("quick-add")) {
    customElements.define(
        "quick-add",
        class QuickAdd extends HTMLElement {
            constructor() {
                super();

                // Get the elements with the "add-to-cart" class
                const addToCartButtons = this.querySelectorAll('.add-to-cart');

                if (document.querySelector("cart-notification")) {
                    this.cartNotification = document.querySelector("cart-notification");
                    this.currentCartPage = false;
                } else {
                    this.cartNotification = document.querySelector("cart-items");
                    this.currentCartPage = true;
                }
                // Add a click event listener to each button
                addToCartButtons.forEach((button) => {
                    button.addEventListener('click', () => {
                        let variantId = button.getAttribute('data-variant-id');
                        let quantity = 1; // or the desired quantity to add to the cart
                        this.onButtonClick(variantId, quantity);
                    });
                });

                // Save a reference to the cart notification element
                this.cartNotification = document.querySelector("cart-notification");
            }

            onButtonClick(variantId, quantity) {
                // Handle the button click here

                this.cartNotification.setActiveElement(document.activeElement);


                let form = JSON.stringify({
                    items: [
                        {
                            "id": variantId,
                            "quantity": quantity,
                        }
                    ],
                    sections: this.currentCartPage
                        ? this.cartNotification.getSectionsToRender().map((section) => section.section)
                        : this.cartNotification.getSectionsToRender().map((section) => section.id),
                    sections_url: window.location.pathname,
                });

                fetch("/cart/add.js", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: form,
                })
                    .then((r) => r.text())
                    .then((data) => {
                        const parsedState = JSON.parse(data);
                        if (this.currentCartPage) {
                            this.cartNotification.renderContents(parsedState);
                            //hide slide cart in collection quick add to cart for upcart app
                            // this.cartNotification.open();
                            // this.cartNotification.autoClose();
                        } else {
                            this.cartNotification.reRenderContents(parsedState);
                            //hide slide cart in collection quick add to cart for upcart app
                            // this.cartNotification.open();
                            // this.cartNotification.autoClose();
                        }

                        if (window.innerWidth >= 1025) {
                            const ctaText = this.querySelector('.addToCartInner');
                            const ctaLabel = this.querySelector('.addToCartInner').innerHTML;
                            if(ctaText){
                                ctaText.textContent = 'Added to cart';
                                setTimeout(() => {

                                    ctaText.textContent = ctaLabel;
                                }, 5000);
                            }
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });

            }

        }
    );
}
